import { render } from "./LeadScoring.vue?vue&type=template&id=01ecde70"
import script from "./LeadScoring.vue?vue&type=script&lang=js"
export * from "./LeadScoring.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andersnielsen/Sites/demo-leverandoroverblik/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__